// extracted by mini-css-extract-plugin
export default {"seminars":"AMWiN_DrWy4EHIbDKXu2","seminarsList":"cLBpHB5f2WUo6YVbP1wX","seminarsContainer":"r5AMo07dfWIKRNaie3Bj"};